import * as React from 'react';
import classNames from 'clsx';

import { MODAL_SEARCH_SUGGESTIONS_CLOSE_BUTTON_TEST_ID } from '../../constants';
import { IModalSuggestionsProps } from '../Suggestion.types';
import ArrowRightSymbolSvg from '../../assets/ArrowRight.svg';

import style from './CloseButton.scss';

type CloseButtonButtonProps = Pick<IModalSuggestionsProps, 'direction'> & {
  onClick: React.MouseEventHandler;
};

export const CloseButton: React.FC<CloseButtonButtonProps> = ({
  direction,
  onClick,
}) => {
  return (
    <div
      className={style.root}
      data-testid={MODAL_SEARCH_SUGGESTIONS_CLOSE_BUTTON_TEST_ID}
      onClick={onClick}
    >
      <ArrowRightSymbolSvg
        className={classNames(style.button, {
          [style.flipped]: direction === 'rtl',
        })}
      />
    </div>
  );
};
